import { render, staticRenderFns } from "./BookingClientDetails.vue?vue&type=template&id=eb039690"
import script from "./BookingClientDetails.vue?vue&type=script&lang=js"
export * from "./BookingClientDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports